export default __webpack_public_path__ + "static/media/0.5251825d.gif";